import React, { Fragment } from 'react';
import Select ,{components} from 'react-select'

class FundOption extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
        }
    }

    handleChange = (selectedOption) => {
        this.setState({
          selectedOption
        })
        this.props.selectedFundOption(selectedOption.value)
    }

    render(){
        const customStyles = {
                option: (provided, state) => ({
                    ...provided,
                    color: 'rgb(0, 114, 172) !important',
                    fontFamily: 'MyriadPro-Regular,  sans-serif !important',
                    fontSize: '16px',
                    fontWeight: 'normal',
                    height: '36px' ,
                    letterSpacing: '0.2px',
                    lineHeight: '24px !important',
                    ':hover': {
                        background: 'rgb(0, 114, 172) !important',
                        color: '#fff !important'
                    }
                  }),
                placeholder: (provided, state) => ({
                ...provided,
                fontWeight: 'normal',
                // fontSize: '13px',
                }),
        }

        const Option = props => {
            const innerProps = { ...props.innerProps, role: 'option', 'aria-disabled': props.isDisabled };
            return <components.Option {...props} innerProps={innerProps} />
        }

        const MenuList = props => {
            const innerProps = { ...props.innerProps, id: props.selectProps.menuId, role: 'listbox', 'aria-expanded': true };
            return <components.MenuList {...props} innerProps={innerProps} />
        }

        const Input = props => {
            // aria-label and aria-labelledby are already spread by the existing props if provided
            const ariaProps = {
                role: props.selectProps.isSearchable ? 'combobox' : 'listbox',
                'aria-owns': props.selectProps.menuId,
                'aria-autocomplete': 'list',
            };

            return <components.Input  {...props} {...ariaProps} />
        };

        return(
            <Fragment style={{width:"1020px"}}>
                 <Select
                     aria-labelledby="aria-label"
                     id="aria-fund-input"
                     name="aria-fund-list"
                     aria-autocomplete="list"
                    styles={customStyles}
                    placeholder = "Please select one of the following Funds"
                    value={this.state.selectedOption}
                    onChange={this.handleChange}
                    options={this.props.itemOption}
                    maxMenuHeight={500}
                     components={{ Option, MenuList, Input }}
                />
            </Fragment>
        )
    }
}

export default FundOption;
